<template>
    <div>
        <div class="plan-con m-t-15">
            <vs-table :data="data" stripe pagination maxItems="15">
                <template slot="header">
                    <vs-row vs-type="flex" vs-align="center">
                        <vs-col vs-w="6">
                            <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.planTemplate')}}</span>
                        </vs-col>
                        <vs-col vs-w="6" vs-type="flex"  vs-justify="flex-end">
                            <vs-button v-role="['admin','manager']" size="small" color="rgb(37, 105, 193)" type="border" style="border-radius: 15px;" @click="handleMethods('create')">
                                + {{$t('message.addPlanTemplate')}}
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </template>
                <template slot="thead">
                    <vs-th>
                        {{$t('message.planTemplateZH')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.planTemplateEN')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.interestRate')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.dividendPeriod')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.manageFee')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.managePeriod')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.length')}}
                    </vs-th>
                    <vs-th>
                        {{$t('message.currency')}}
                    </vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td>
                            {{tr.name_zh}}
                        </vs-td>
                        <vs-td>
                            {{tr.name_en}}
                        </vs-td>
                        <vs-td>
                            {{tr.interestRate}}
                        </vs-td>
                        <vs-td>
                            {{tr.dividendPeriod}}
                        </vs-td>
                        <vs-td>
                            {{tr.manageFee}}
                        </vs-td>
                        <vs-td>
                            {{tr.managePeriod}}
                        </vs-td>
                        <vs-td>
                            {{tr.length}}
                        </vs-td>
                        <vs-td>
                            {{$t(`message.${tr.currency}`)}}
                        </vs-td>
                        <vs-td>
                            <vs-button v-role="['admin','manager']" size="small" color="rgb(37, 105, 193)" @click="handleMethods('update',tr)">{{$t('message.edit')}}</vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup :active.sync="openFlag" title=" ">
                <div class="card-title">
                    {{ type === 'create' ? $t('message.newPlanTemplate') : $t('message.updatePlanTemplate')}}
                </div>
                <vs-row class="m-t-15">
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.name_zh"  :placeholder="$t('message.planTemplateZH')" style="width: 100%"></vs-input>
                    </vs-col>
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.name_en"  :placeholder="$t('message.planTemplateEN')" style="width: 100%"></vs-input>
                    </vs-col>
                </vs-row>
                <vs-row class="m-t-15">
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.interestRate" type="number" :placeholder="plan.interestRate === 0 ? '' : $t('message.interestRate')" style="width: 100%"></vs-input>
                    </vs-col>
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.dividendPeriod" type="number" :placeholder="plan.dividendPeriod === 0 ? '' : $t('message.dividendPeriod')" style="width: 100%"></vs-input>
                    </vs-col>
                </vs-row>
                <vs-row class="m-t-15">
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.manageFee" type="number" :placeholder="plan.manageFee === 0 ? '' : $t('message.manageFee')" style="width: 100%"></vs-input>
                    </vs-col>
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.managePeriod" type="number" :placeholder="plan.managePeriod === 0 ? '' : $t('message.managePeriod')" style="width: 100%"></vs-input>
                    </vs-col>
                </vs-row>
                <vs-row class="m-t-15">
                    <vs-col vs-w="6">
                        <vs-input v-model="plan.length" type="number" :placeholder="plan.length === 0 ? '' : $t('message.length')" style="width: 100%"></vs-input>
                    </vs-col>
                    <vs-col vs-w="6">
                        <vs-select v-model="plan.currency" autocomplete :placeholder="$t('message.currency')" style="width: 100%">
                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in currencyOpt" />
                        </vs-select>
                    </vs-col>
                </vs-row>
                <vs-row class="m-t-3">
                    <vs-col vs-w="12" vs-type="flex" vs-justify="center" v-if="type === 'create'">
                        <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn" @click="onCreatePlan()">{{$t('message.add')}}</vs-button>
                    </vs-col>
                    <vs-col vs-w="12" vs-type="flex" vs-justify="center" v-else>
                        <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-r-2" @click="onUpdatePlan()">{{$t('message.update')}}</vs-button>
                        <vs-button size="small" color="danger" class="stribtn" @click="onDeletePlan()">{{$t('message.delete')}}</vs-button>
                    </vs-col>
                </vs-row>
            </vs-popup>
        </div>
    </div>
</template>

<script>
import {mapGetters,mapActions} from 'vuex'
import $cookies from "vue-cookies";
import errorHandle from "@/assets/utils/errorHandle";
export default {
    beforeRouteEnter(to, from, next){
        if($cookies.get('role') !== 'user'){
            next()
        }else{
            next("/")
        }
    },
    data() {
        return {
            lang:'',
            token:'',
            data:[],
            openFlag: false,
            type: "create",
            plan: {
                name_zh: "",
                name_en: "",
                interestRate: "",
                dividendPeriod: "",
                manageFee: "",
                managePeriod: "",
                currency: "HKD",
                length: "",
            },
            currencyOpt:[
                {value:'HKD',text:this.$t('message.HKD')},
                {value:'USD',text:this.$t('message.USD')},
                {value:'EUR',text:this.$t('message.EUR')},
                {value:'RMB',text:this.$t('message.RMB')},
            ],
        }
    },
    created() {
        this.lang = this.$cookies.get('lang');
        this.token = this.$cookies.get('token');
        let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate?access_token=' + this.$cookies.get('token');
        fetch(url).then((res) => {
            return res.json()
        }).then((data) => {
            this.data = data.responseDetail.data;
        })
    },
    computed:{
        ...mapGetters(["currentUser"])
    },
    methods: {
        onReload(){
            let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate?access_token=' + this.$cookies.get('token');
            fetch(url).then((res) => {
                return res.json()
            }).then((data) => {
                this.data = data.responseDetail.data;
            })

        },
        handleMethods(type, item){
            this.type = type;
            switch (type){
                case "create": {
                    this.plan = {
                        name_zh: "",
                        name_en: "",
                        interestRate: "",
                        dividendPeriod: "",
                        manageFee: "",
                        managePeriod: "",
                        currency: "",
                        length: "",
                    };
                    this.openFlag = true;
                    break;
                }
                case "update": {
                    this.plan = {...item};
                    this.openFlag = true;
                    break;
                }
            }
        },
        onCreatePlan(){
            const {name_zh , name_en, interestRate, dividendPeriod, manageFee, managePeriod, currency, length  } = this.plan;

            let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate?access_token=' + this.token;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name_zh , name_en, interestRate, dividendPeriod, manageFee, managePeriod, currency, length
                })
            }).then((response) => {
                return response.json()
            }).catch((error) => {
                console.log(error);
            }).then((result) => {
                if(result.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.createSuccess'),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                    this.openFlag = false;
                    this.onReload();
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t(`message.${errorHandle(result.responseDetail)}`) + this.$t('message.must_be_number'),
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            });
        },
        onUpdatePlan(){
            const {name_zh , name_en, interestRate, dividendPeriod, manageFee, managePeriod, currency, length  } = this.plan;
            let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate/' + this.plan._id + '?access_token=' + this.token;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name_zh , name_en, interestRate, dividendPeriod, manageFee, managePeriod, currency, length
                })
            }).then((response) => {
                return response.json()
            }).catch((error) => {
                console.log(error);
            }).then((result) => {
                if(result.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.updateSuccess'),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                    this.openFlag = false;
                    this.onReload();
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t(`message.${errorHandle(result.responseDetail)}`) + this.$t('message.must_be_number'),
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            });
        },
        onDeletePlan(){
            console.log(this.plan._id)
            let url = process.env.VUE_APP_API_BASEURL + '/api/planTemplate/delete/' + this.plan._id + '?access_token=' + this.token;
            fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                return response.json()
            }).catch((error) => {
                console.log(error);
            }).then((result) => {
                if(result.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.deleteSuccess'),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                    this.openFlag = false;
                    this.onReload();
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: result.responseMsg + ". " + result.responseDetail,
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            });
        }
    },
}
</script>

<style scoped>
@import '../assets/css/table.css';
</style>
